import { NgModule } from '@angular/core';
import { CapitalisePipe } from './capitalise.pipe';
import { ScaleToFitDirective } from './scale-to-fit.directive';
import { AltSrcDirective } from './alt-src.directive';

export * from './capitalise.pipe';
export * from './scale-to-fit.directive';
export * from './alt-src.directive';
export * from './repeat.pipe';

export const COMMON_PIPES = [ScaleToFitDirective, AltSrcDirective, CapitalisePipe];
@NgModule({
    imports: [...COMMON_PIPES],
    exports: [...COMMON_PIPES],
    declarations: [],
    providers: []
})
export class PipesAndDirectivesModule {}
